// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getMedios as listMediosAPI,
    getMedio as getMedioAPI,
    addMedio as addMedioAPI,
    updateMedio as updateMedioAPI,
    deleteMedio as deleteMedioAPI,
} from '../../helpers/';

// import { APICore, setAuthorization } from '../../helpers/api/apiCore';
import { mediosApiResponseError, mediosApiResponseSuccess } from './actions';
import { MediosActionTypes } from './constants';

// const api = new APICore();

/**
 * Get contacto
 * @param {*} payload - username and password
 */
function* getMedio({ payload: { id } }) {
    try {
        const response = yield call(getMedioAPI, id );
        const medioItem = response.data.data;
        yield put(mediosApiResponseSuccess(MediosActionTypes.GET_MEDIO, medioItem));
    } catch (error) {
        yield put(mediosApiResponseError(MediosActionTypes.GET_MEDIO, error));
    }
}

function* addMedio({payload:medio}){
    try{
        const response = yield call(addMedioAPI,{...medio})
        const medioItem = response.data.data
        yield put(mediosApiResponseSuccess(MediosActionTypes.ADD_MEDIO,medioItem))
    } catch(error){
        yield put(mediosApiResponseError(MediosActionTypes.ADD_MEDIO,error))
    }
}

function* updateMedio({payload:medio}){
    try{
        const response = yield call(updateMedioAPI,{...medio})
        const medioItem = response.data.data
        yield put(mediosApiResponseSuccess(MediosActionTypes.UPDATE_MEDIO,medioItem))
    }catch(error){
        yield put(mediosApiResponseError(MediosActionTypes.UPDATE_MEDIO,error))
    }
}
function* deleteMedio({payload:{id}}){
    try{
        const response = yield call(deleteMedioAPI,id)
        const medioItem = response.data.id
        yield put(mediosApiResponseSuccess(MediosActionTypes.DELETE_MEDIO,medioItem))
    }catch(error){
        yield put(mediosApiResponseError(MediosActionTypes.DELETE_MEDIO,error))
    }
}

/**
 * List contactos
 */
function* listMedios({payload:params}) {
    try {
        const response = yield call(listMediosAPI, { ...params });
        const listaMedios = response.data.data;
        yield put(mediosApiResponseSuccess(MediosActionTypes.LIST_MEDIOS, listaMedios));
    } catch (error) {
        yield put(mediosApiResponseError(MediosActionTypes.LIST_MEDIOS, error));
    }
}


export function* watchGetMedio(): any {
    yield takeEvery(MediosActionTypes.GET_MEDIO, getMedio);
}

export function* watchListMedios(): any {
    yield takeEvery(MediosActionTypes.LIST_MEDIOS, listMedios);
}

export function* watchAddMedio():any{
    yield takeEvery(MediosActionTypes.ADD_MEDIO,addMedio)
}
export function* watchUpdateMedio():any{
    yield takeEvery(MediosActionTypes.UPDATE_MEDIO,updateMedio)
}
export function* watchDeleteMedio():any{
    yield takeEvery(MediosActionTypes.DELETE_MEDIO,deleteMedio)
}


function* mediosSaga(): any {
    yield all([
        fork(watchGetMedio),
        fork(watchListMedios),
        fork(watchAddMedio),
        fork(watchUpdateMedio),
        fork(watchDeleteMedio),
    ]);
}

export default mediosSaga;
